export default function DataDeletion() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f0fdf4 0%, #ffffff 60%)",
      padding: "48px 24px",
      fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      color: "#111827"
    }}>
      <div style={{ maxWidth: 780, margin: "0 auto" }} data-testid="data-deletion-page" dir="ltr">
        <a href="/" style={{ color: "#047857", textDecoration: "none", fontWeight: 600 }}>← SocialHub</a>

        <h1 style={{ fontSize: 40, fontWeight: 800, marginTop: 24, marginBottom: 8 }}>
          User Data Deletion / حذف بيانات المستخدم
        </h1>
        <p style={{ color: "#6b7280", marginBottom: 32 }}>Last updated: February 2026</p>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12 }}>English</h2>
          <p style={{ lineHeight: 1.7 }}>
            SocialHub (<a href="https://app.letsm.io" style={{ color: "#047857" }}>app.letsm.io</a>) stores
            minimal Meta (Facebook / Instagram) data required to connect your business pages to our omnichannel
            inbox — namely: page IDs, page access tokens, Instagram business account IDs, and message
            metadata routed through our platform.
          </p>
          <p style={{ lineHeight: 1.7, marginTop: 12 }}>
            <strong>To request deletion of all your data:</strong>
          </p>
          <ol style={{ lineHeight: 1.9, paddingInlineStart: 20 }}>
            <li>Log in to your SocialHub dashboard.</li>
            <li>Go to <strong>Channels</strong> and click <strong>Disconnect</strong> next to any connected Facebook / Instagram / WhatsApp page. This immediately revokes tokens and removes the inbox.</li>
            <li>To delete your entire account and all associated data, email us at
              {" "}<a href="mailto:support@letsm.io" style={{ color: "#047857" }}>support@letsm.io</a>{" "}
              from the email address associated with your account. We will confirm and permanently erase all data within 30 days.</li>
          </ol>
          <p style={{ lineHeight: 1.7, marginTop: 12 }}>
            You may also revoke SocialHub's access directly from Facebook at{" "}
            <a href="https://www.facebook.com/settings?tab=business_tools" style={{ color: "#047857" }}>
              Facebook Business Integrations settings
            </a>.
          </p>
        </section>

        <section style={{ borderTop: "1px solid #e5e7eb", paddingTop: 32 }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12 }}>العربية</h2>
          <p style={{ lineHeight: 1.8, direction: "rtl" }}>
            تحتفظ SocialHub بأقل قدر ممكن من بيانات Meta (فيسبوك / إنستغرام) اللازمة لربط صفحات
            أعمالك بصندوق الرسائل الموحّد الخاص بنا: معرّفات الصفحات، توكن الصفحة، معرّف حساب
            إنستغرام التجاري، وبيانات الرسائل المُوجَّهة عبر منصتنا.
          </p>
          <p style={{ lineHeight: 1.8, marginTop: 12, direction: "rtl" }}>
            <strong>لطلب حذف بياناتك بالكامل:</strong>
          </p>
          <ol style={{ lineHeight: 2, paddingInlineStart: 20, direction: "rtl", textAlign: "right" }}>
            <li>سجّل الدخول إلى لوحة SocialHub.</li>
            <li>اذهب إلى صفحة <strong>القنوات</strong> واضغط <strong>Disconnect</strong> بجانب أي صفحة متصلة. سيتم إبطال التوكن وحذف الصندوق فوراً.</li>
            <li>لحذف حسابك بالكامل، أرسل بريداً إلى{" "}
              <a href="mailto:support@letsm.io" style={{ color: "#047857" }}>support@letsm.io</a>{" "}
              من نفس البريد المسجّل، وسنؤكد الحذف الدائم خلال 30 يوماً.</li>
          </ol>
        </section>
      </div>
    </div>
  );
}
